import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './index.module.sass';

interface Props {
  children: React.ReactNode;
  icon?: any; // Not sure how to fix it
  title?: string | React.ReactNode;
}

export const Template: React.FC<Props> = ({ children, icon, title }) => (
  <div className="d-flex flex-column justify-content-around py-2 border-bottom text-dark">
    <div className="font-weight-bolder d-flex flex-row">
      {icon && <FontAwesomeIcon className={`${styles.icon} mr-1 mb-2 fs-7`} icon={icon} />}
      {title}
    </div>

    <div className="text-truncate">{children}</div>
  </div>
);
